/* eslint-disable no-console */
import $http from '@common-vue/util/src/modules/http';
import { Cookie } from '@vue-util/cookie';
import {
  FETCH_LOCATIONS,
  FETCH_GEOCODE,
  FETCH_UPS_LOCATIONS,
  FETCH_MACYS_LOCATIONS,
  FETCH_FCC_STORE_LOCATIONS,
  RESET_STORE_ACTION,
  SET_STORE,
  FETCH_STORES_BY_ZIPCODE,
  FETCH_LOCATIONS_ADDRESS,
  FETCH_FEDEX_LOCATIONS,
} from './types/actions';
import {
  SET_LOCATIONS,
  SET_GEOCODE,
  SET_STORES,
  SET_UNAVAILABLE_STORES,
  SET_STORES_ERROR,
  SET_API_LOADING,
  RESET_STORE,
  SET_SELECTED_STORE,
  SET_SEARCH_BY_ZIPCODE,
  SET_DIVISION_NUMBER,
  SET_RESULTS_DISPLAYED,
  SET_LOCATION_RADIUS,
  SET_PREFILLED_ZIPCODE,
  SET_IS_BRIDAL,
  SET_PAGE,
  SET_BAG_ITEMS,
  SET_UPC_NUMBER,
  SET_USE_FCC_API,
  SET_SHOW_ACCORDION,
  SET_CURBSIDE_HOURS,
  SET_AVAILABILITY,
  SET_FULFILLMENT_ZIPCODE_EMPTY_STORE,
  SET_FCC_MACYS_API_KEY,
  SET_SEARCH_LOCATION_BY_ADDRESS,
  SET_BT_ITEMS,
  SET_PRODUCT_ID,
  SET_AREA_RUG_ITEMS,
} from './types/mutations';
import {
  UPS,
  MSTORE,
  LABELFREE,
  BSTORE,
  MDROPNGO,
  BDROPNGO,
  BTSTORE,
  ERROR_MESSAGES,
  FCC_FIELDS,
  FEDEX,
  OPR_DIV_NO_BCOM,
  EXCLUDED_LOCATION_IDS,
} from './types/constants';
import {
  formatStringCase, getDisplayUpsHours, getDisplayHoursFromLocationService, formattedFccResponse, getPickupItemInfo, formatBTItemResponse,
} from './utils/commonUtils';

export function appendParameters(url, params) {
  if (params !== null && typeof params === 'object') {
    let paramString = '';
    for (const key of Object.keys(params)) { // eslint-disable-line no-restricted-syntax
      // append query param only if the value is not empty
      if (params[key] !== undefined && params[key] !== '') {
        paramString = `${paramString + key}=${params[key]}&`;
      }
    }
    // add params to base URL and remove last '&'
    if (paramString.length > 0) {
      return `${url}?${paramString.slice(0, -1)}`;
    }
  }
  return url;
}

export const locations = {
  namespaced: true,
  state() {
    return {
      places: [],
      geoCode: null,
      prefilledZipCode: null,
      searchByZipCode: null,
      divisionNumber: null,
      resultsDisplayed: null,
      stores: [],
      unavailableStores: [],
      storesError: {
        status: null,
        error: null,
        message: null,
      },
      selectedStore: null,
      isLoading: false,
      locationRadius: null,
      isBridal: null,
      page: null,
      bagItems: [],
      useFccApi: false,
      showAccordion: false,
      showCurbsideHours: false,
      showAvailability: false,
      upcNumber: null,
      searchLocationByAddress: false,
      fulfillmentZipcodeEmptyStore: false,
      btItems: false,
      productId: null,
      areaRugItems: false,
    };
  },
  getters: {
    hostlink(_, __, rootState) {
      return rootState?.envProps?.locatorHostLink || '';
    },
    xMacysApiKey(_, __, rootState) {
      return rootState?.envProps?.xMacysApiKey || '';
    },
  },
  mutations: {
    [SET_LOCATIONS]: (state, places) => {
      state.places = places;
    },
    [SET_GEOCODE]: (state, geoCode) => {
      state.geoCode = geoCode;
    },
    [SET_STORES]: (state, stores) => {
      state.stores = stores;
    },
    [SET_UNAVAILABLE_STORES]: (state, unavailableStores) => {
      state.unavailableStores = unavailableStores;
    },
    [SET_USE_FCC_API]: (state, useFccApi) => {
      state.useFccApi = useFccApi;
    },
    [SET_STORES_ERROR]: (state, data) => {
      const {
        status = null, error = null, message = null, messageEdit = false,
      } = { ...(data || {}) };
      state.storesError.status = status;
      state.storesError.error = error;
      state.storesError.message = messageEdit ? `${message} ${state.locationRadius} miles of ${state.geoCode[0].formatted_address}` : message;
    },
    [SET_API_LOADING]: (state, isLoading) => {
      state.isLoading = isLoading;
    },
    [RESET_STORE]: (state) => {
      state.stores = [];
      state.geoCode = null;
      state.places = [];
    },
    [SET_SELECTED_STORE]: (state, selectedStore) => {
      state.selectedStore = selectedStore;
    },
    [SET_SEARCH_BY_ZIPCODE]: (state, searchByZipCode) => {
      state.searchByZipCode = searchByZipCode;
    },
    [SET_DIVISION_NUMBER]: (state, divisionNumber) => {
      state.divisionNumber = divisionNumber;
    },
    [SET_RESULTS_DISPLAYED]: (state, resultsDisplayed) => {
      state.resultsDisplayed = resultsDisplayed;
    },
    [SET_LOCATION_RADIUS]: (state, locationRadius) => {
      state.locationRadius = locationRadius;
    },
    [SET_PREFILLED_ZIPCODE]: (state, prefilledZipCode) => {
      state.prefilledZipCode = prefilledZipCode;
    },
    [SET_IS_BRIDAL]: (state, bridalFlag) => {
      state.isBridal = bridalFlag;
    },
    [SET_PAGE]: (state, page) => {
      state.page = page;
    },
    [SET_BAG_ITEMS]: (state, items) => {
      state.bagItems = items;
    },
    [SET_UPC_NUMBER]: (state, upc) => {
      state.upcNumber = upc;
    },
    [SET_SHOW_ACCORDION]: (state, showAccordion) => {
      state.showAccordion = showAccordion;
    },
    [SET_CURBSIDE_HOURS]: (state, showCurbsideHours) => {
      state.showCurbsideHours = showCurbsideHours;
    },
    [SET_AVAILABILITY]: (state, showAvailability) => {
      state.showAvailability = showAvailability;
    },
    [SET_FULFILLMENT_ZIPCODE_EMPTY_STORE]: (state, fulfillmentZipcodeEmptyStore) => {
      state.fulfillmentZipcodeEmptyStore = fulfillmentZipcodeEmptyStore;
    },
    [SET_FCC_MACYS_API_KEY]: (state, fccMacysApiKey) => {
      state.fccMacysApiKey = fccMacysApiKey;
    },
    [SET_SEARCH_LOCATION_BY_ADDRESS]: (state, searchLocationByAddress) => {
      state.searchLocationByAddress = searchLocationByAddress;
    },
    [SET_BT_ITEMS]: (state, btItems) => {
      state.btItems = btItems;
    },
    [SET_PRODUCT_ID]: (state, productId) => {
      state.productId = productId;
    },
    [SET_AREA_RUG_ITEMS]: (state, areaRugItems) => {
      state.areaRugItems = areaRugItems;
    },

  },
  actions: {
    // GOOGLE places api call with Zipcode and locality type
    async [FETCH_LOCATIONS]({ commit, getters }, { input = null }) {
      const { hostlink } = getters;

      try {
        const url = `${hostlink}/my-orders/returns/select-return/places`;
        const response = await $http.post(url, { input });
        commit(SET_LOCATIONS, response.data);
      } catch (error) {
        commit(SET_STORES_ERROR, { error: '40490', message: ERROR_MESSAGES['40490'] });
      }
    },

    // GOOGLE places api call with address type
    async [FETCH_LOCATIONS_ADDRESS]({ commit, getters }, { input = null }) {
      const { hostlink } = getters;

      try {
        const url = `${hostlink}/my-orders/returns/select-return/placesAddress`;
        const response = await $http.post(url, { input });
        commit(SET_LOCATIONS, response.data);
      } catch (error) {
        commit(SET_STORES_ERROR, { error: '40490', message: ERROR_MESSAGES['40490'] });
      }
    },

    // GOOGLE geocode api call
    async [FETCH_GEOCODE]({
      dispatch, commit, state, getters,
    }, {
      address = null, locationType, useMspLocatorApi, client = 'locator', separateOutlets,
    }) {
      const { hostlink } = getters;
      try {
        commit(SET_LOCATIONS, []);
        commit(SET_API_LOADING, true);
        const url = `${hostlink}/my-orders/returns/select-return/geocode`;
        const response = await $http.post(url, { address });
        if (response.data?.length > 0) {
          commit(SET_GEOCODE, response.data);
          commit(SET_FULFILLMENT_ZIPCODE_EMPTY_STORE, false);
        } else {
          commit(SET_STORES, []);
          if (client === 'locator') {
            commit(SET_FULFILLMENT_ZIPCODE_EMPTY_STORE, false);
            throw Error();
          }
          if (client === 'fulfillment') {
            commit(SET_FULFILLMENT_ZIPCODE_EMPTY_STORE, true);
          }
        }
        // Load only when client is locator
        if (client === 'locator') {
          if (locationType === FEDEX) return dispatch(FETCH_FEDEX_LOCATIONS, { locationType, address });

          if ([UPS, LABELFREE].includes(locationType)) return dispatch(FETCH_UPS_LOCATIONS, { locationType, useMspLocatorApi });
          // if ([MSTORE, BSTORE, MDROPNGO, BDROPNGO].includes(locationType)) return dispatch(FETCH_MACYS_LOCATIONS, { locationType });
          if ([MSTORE, BSTORE, MDROPNGO, BDROPNGO, BTSTORE].includes(locationType)) {
            const { useFccApi } = state;
            return dispatch(useFccApi
              ? FETCH_FCC_STORE_LOCATIONS
              : FETCH_MACYS_LOCATIONS,
            { locationType, separateOutlets });
          }
        }
      } catch (error) {
        if (!address) {
          commit(SET_STORES, []);
        }
        commit(SET_STORES_ERROR, { error: '40490', message: ERROR_MESSAGES['40490'] });
      } finally {
        commit(SET_API_LOADING, false);
      }
      return [];
    },

    // UPS api call
    async [FETCH_UPS_LOCATIONS]({ commit, state, getters }, { locationType, useMspLocatorApi }) {
      const { hostlink } = getters;
      const { geoCode } = state;
      if (geoCode?.length) {
        const {
          address_components: addressComponents,
          geometry: {
            location: { lat: latitude, lng: longitude },
          },
        } = geoCode[0];
        let localityObj = addressComponents.find(({ types }) => types.includes('locality'));
        // if city is empty, get the state
        if (!localityObj) {
          localityObj = addressComponents.find(({ types }) => types.includes('administrative_area_level_1'));
        }
        // Get the country details
        const countryObj = addressComponents.find(({ types }) => types.includes('country'));
        const LOCATIONS_RADIUS = 100;
        const LABEL_FREE_LOCATION_SEARCH = 'LABEL-FREE';
        const upsLimit = 50;
        const params = {
          latitude,
          longitude,
          radius: LOCATIONS_RADIUS,
          type: locationType === LABEL_FREE_LOCATION_SEARCH ? 'label-free' : '',
          limit: upsLimit,
          city: localityObj.long_name,
          countryCode: countryObj.short_name,
        };
        try {
          commit(SET_API_LOADING, true);
          commit(SET_STORES_ERROR, null);
          let url;
          if (useMspLocatorApi) {
            url = appendParameters(`${hostlink}/api/ordermodsreturns/v1/returns/locations/ups`, params);
          } else {
            url = appendParameters(`${hostlink}/xapi/ordermodsreturns/v1/locations/ups`, params);
          }
          const response = await $http.get(url);
          const data = response?.data?.UPSLocatorLocations?.upsStoreDetails?.map((item) => {
            const {
              consigneeName, distance, addressLine, city, state: st, primaryPostcode, upsDayOfWeek,
            } = item;
            return ({
              name: formatStringCase(consigneeName),
              address: [formatStringCase(addressLine), city, st, primaryPostcode].join(', '),
              today: getDisplayUpsHours(upsDayOfWeek)?.today || null,
              tomorrow: getDisplayUpsHours(upsDayOfWeek)?.tomorrow || null,
              distance: `${distance.split(' ')[0]} mi`,
            });
          }) || [];
          commit(SET_STORES, data);
          if (!data.length) {
            commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType] });
          }
          return data;
        } catch (error) {
          const errorCode = error?.response?.data?.errors?.error[0]?.errorCode || '';
          if (errorCode === '40490') {
            commit(SET_STORES_ERROR, { error: errorCode, message: ERROR_MESSAGES[errorCode] });
          } else {
            commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType] });
          }
          return [];
        } finally {
          commit(SET_API_LOADING, false);
        }
      }
      return [];
    },

    async [FETCH_FEDEX_LOCATIONS]({ commit, state, getters }, { locationType, address }) {
      const { hostlink } = getters;
      const { geoCode } = state;
      if (geoCode?.length) {
        const {
          address_components: addressComponents,
          geometry: {
            location: { lat: latitude, lng: longitude },
          },
        } = geoCode[0];

        const localityObj = addressComponents.find(({ types }) => types.includes('locality'));
        const countryCode = 'US';
        const { locationRadius: radius, resultsDisplayed: limit } = state;

        const params = {
          latitude,
          longitude,
          radius,
          city: localityObj.long_name,
          countryCode,
          limit,
        };
        try {
          commit(SET_API_LOADING, true);
          commit(SET_STORES_ERROR, null);
          const url = appendParameters(`${hostlink}/api/ordermodsreturns/v1/returns/locations/fedex`, params);
          const response = await $http.get(url);
          const data = response?.data?.locatorLocations?.storeDetails?.map((item) => {
            const {
              storeDisplayName, distance, addressLine, city, state: st, primaryPostcode, dayOfWeek,
            } = item;
            return ({
              name: formatStringCase(storeDisplayName),
              address: [formatStringCase(addressLine), city, st, primaryPostcode].join(', '),
              today: getDisplayUpsHours(dayOfWeek)?.today || null,
              tomorrow: getDisplayUpsHours(dayOfWeek)?.tomorrow || null,
              distance: `${distance.split(' ')[0]} mi`,
            });
          }) || [];
          commit(SET_STORES, data);
          if (!data.length) {
            commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType](address, radius) });
          }
          return data;
        } catch (error) {
          const errorCode = error?.response?.data?.errors?.error[0]?.errorCode || '';
          if (errorCode === '40490') {
            commit(SET_STORES_ERROR, { error: errorCode, message: ERROR_MESSAGES[errorCode] });
          } else {
            commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType](address, radius) });
          }
          return [];
        } finally {
          commit(SET_API_LOADING, false);
        }
      }
      return [];
    },

    // Common location api call using lat and long for fetch macys store location
    async [FETCH_MACYS_LOCATIONS]({
      commit, state, rootState, getters,
    }, { locationType, separateOutlets }) {
      const { hostlink, xMacysApiKey } = getters;
      const { geoCode } = state;
      if (geoCode?.length) {
        const {
          geometry: {
            location: { lat: latitude, lng: longitude },
          },
        } = geoCode[0];
        const MACYS_STORE_DIVISION_NUMBER = 12;
        const BLOOMS_STORE_DIVISION_NUMBER = 13;
        const {
          resultsDisplayed, locationRadius, areaRugItems,
        } = state;
        const divisionNumber = [MSTORE, MDROPNGO].includes(locationType) ? MACYS_STORE_DIVISION_NUMBER : BLOOMS_STORE_DIVISION_NUMBER;

        const clientId = divisionNumber === 12 ? 'MCOM' : 'BCOM';
        const requestHeader = {
          'x-macys-apikey': xMacysApiKey,
          'X-Client-Id': clientId,
          'X-Sub-Client-Id': clientId,
        };
        const dropNGoStoreNumbers = rootState?.envProps?.dropNGoStoreNumbers?.split(',')?.map(Number);
        try {
          commit(SET_API_LOADING, true);
          commit(SET_STORES_ERROR, null);
          const params = {
            limit: resultsDisplayed,
            radius: locationRadius,
            ...(areaRugItems && { features: 'Fine Rug Gallery' }),
          };
          const url = appendParameters(`${hostlink}/commonlocations/v1/locations/divn/${divisionNumber}/latitude/${latitude}/longitude/${longitude}`, params);
          const response = await $http.get(url, { headers: requestHeader });
          let data = response?.data?.items;

          if (locationType === MDROPNGO && dropNGoStoreNumbers?.length > 0) {
            data = data?.filter((item) => dropNGoStoreNumbers?.includes(item.storeNumber));
            data = data?.sort((a, b) => (
              parseFloat(a?.geoLocation?.distance ?? locationRadius) - parseFloat(b?.geoLocation?.distance ?? locationRadius)
            )).slice(0, resultsDisplayed);
          }

          if (process.env.ENTRY_POINT === 'bcom' && separateOutlets) {
            data = data?.filter((item) => item.operDivNbr !== OPR_DIV_NO_BCOM && !EXCLUDED_LOCATION_IDS.includes(item.locationNumber));
          }

          data = data?.map((item) => {
            const {
              name,
              addresses,
              workingHours,
              curbsideHours,
              locationNumber,
              phoneNumber,
              storeNumber,
              geoLocation,
            } = item;
            const {
              addrLine1, city, state: st, zipCode,
            } = addresses[0];

            const localStorageModel = {
              name,
              storeNumber,
              locationNumber,
              address: addresses[0],
              geoLocation,
              schedule: {
                todaysHours: workingHours ? workingHours[0] : 'Closed',
                tomorrowsHours: workingHours ? workingHours[1] : 'Closed',
              },
              lastAccessDate: workingHours ? workingHours[0].operationDate : 'Closed',
              phoneNumber,
            };

            return ({
              locationNumber,
              localStorageModel,
              storeNumber,
              name: formatStringCase(name),
              address: [addrLine1, city, st, zipCode.substring(0, 5)].join(', '),
              today: workingHours ? getDisplayHoursFromLocationService(workingHours)?.today : 'Closed',
              tomorrow: workingHours ? getDisplayHoursFromLocationService(workingHours)?.tomorrow : 'Closed',
              curbsideToday: curbsideHours ? getDisplayHoursFromLocationService(curbsideHours)?.today : 'Closed',
              curbsideTomorrow: curbsideHours ? getDisplayHoursFromLocationService(curbsideHours)?.tomorrow : 'Closed',
              ...(geoLocation?.distance ? { distance: `${Number.parseFloat(geoLocation.distance).toFixed(1)} ${geoLocation.unitDistance.substr(0, 2)}` } : {}),
            });
          }) || [];
          commit(SET_STORES, data);
          if (!data.length) {
            commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType], messageEdit: true });
          }
          return data;
        } catch (error) {
          const errorCode = error?.response?.data?.errors?.error[0]?.errorCode || '';
          if (errorCode === '40490') {
            commit(SET_STORES_ERROR, { error: errorCode, message: ERROR_MESSAGES[errorCode] });
          } else {
            commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType], messageEdit: true });
          }
          return [];
        } finally {
          commit(SET_API_LOADING, false);
        }
      }
      return [];
    },

    // FCC api call for fetch macys store location
    async [FETCH_FCC_STORE_LOCATIONS]({ commit, state, getters }, { locationType }) {
      const { hostlink } = getters;
      const {
        geoCode, bagItems, divisionNumber, upcNumber, showAccordion, fccMacysApiKey, page, btItems, productId,
      } = state;
      if (geoCode?.length) {
        const {
          geometry: {
            location: { lat: latitude, lng: longitude },
          },
        } = geoCode[0];
        const {
          resultsDisplayed, locationRadius,
        } = state;
        let envTarget = window.location.host.split('.')[1] || '';

        if (envTarget.toLowerCase() === 'macys') {
          envTarget = 'mcom';
        } else if (envTarget.toLowerCase() === 'bloomingdales') {
          envTarget = 'bcom';
        }

        const macysApiKey = fccMacysApiKey;

        const requestHeader = {
          'X-Macys-ClientId': `${page}UI`,
          'x-macys-apikey': macysApiKey,
          target: envTarget,
        };

        try {
          commit(SET_API_LOADING, true);
          commit(SET_STORES_ERROR, null);
          const upcs = showAccordion ? bagItems.map((item) => item.upcNumber).join() : upcNumber;
          const bagGuid = divisionNumber === 12 ? Cookie.get('macys_bagguid') : Cookie.get('bloomingdales_bagguid');

          const params = {
            radius: `M${locationRadius}`,
            latitude,
            longitude,
            _limit: resultsDisplayed,
            _fields: FCC_FIELDS,
          };
          if (bagGuid) {
            params.bagGuid = bagGuid;
          }
          if (btItems) {
            params.excludeOutlets = true;
            params.productId = productId;
          } else {
            params.upcNumber = upcs;
          }
          const url = appendParameters(`${hostlink}/digitalstore/api/store/v2/stores`, params);
          const response = await $http.get(url, { headers: requestHeader });
          let availableStores = btItems ? formatBTItemResponse(response?.data?.stores?.store).available : formattedFccResponse(response?.data?.stores?.store).available; // eslint-disable-line max-len
          const unavailableStores = btItems ? formatBTItemResponse(response?.data?.stores?.store).unavailable.map((store) => store.name) : formattedFccResponse(response?.data?.stores?.store).unavailable.map((store) => store.name); // eslint-disable-line max-len

          availableStores = availableStores?.map((store) => {
            const {
              name,
              address,
              locationNumber,
              geoLocation,
              inventories,
              cutOffTime,
              phoneNumber,
              storeNumber,
            } = store;
            const {
              line1, city, state: st, zipCode,
            } = address;

            const schedule = store.schedule ? store.schedule : '';

            const pickupItemInfo = showAccordion ? getPickupItemInfo(inventories, bagItems) : {};

            const localStorageModel = {
              name,
              storeNumber,
              locationNumber,
              address,
              geoLocation,
              schedule: {
                todaysHours: schedule.workingHours ? schedule.workingHours[0] : 'Closed',
                tomorrowsHours: schedule.workingHours ? schedule.workingHours[1] : 'Closed',
              },
              lastAccessDate: schedule.workingHours ? schedule.workingHours[0].operationDate : 'Closed',
              phoneNumber,
            };

            return ({
              locationNumber,
              name: formatStringCase(name),
              address: [line1, city, st, zipCode.substring(0, 5)].join(', '),
              pickupItemInfo,
              storeNumber,
              today: schedule.workingHours ? getDisplayHoursFromLocationService(schedule.workingHours)?.today : 'Closed',
              tomorrow: schedule.workingHours ? getDisplayHoursFromLocationService(schedule.workingHours)?.tomorrow : 'Closed',
              curbsideToday: schedule.curbsideHours ? getDisplayHoursFromLocationService(schedule.curbsideHours)?.today : 'Closed',
              curbsideTomorrow: schedule.curbsideHours ? getDisplayHoursFromLocationService(schedule.curbsideHours)?.tomorrow : 'Closed',
              pickupRelativeDay: cutOffTime ? cutOffTime.pickupRelativeDay : '', // only used cutOffTime here since there is talks of removing curbside related hours
              bossAvailabilityMessage: divisionNumber === 12 ? inventories.inventory[0].storeInventory.bossAvailabilityMessage : '5-8 business days',
              bopsAvailability: inventories.inventory[0].storeInventory.bopsAvailability,
              bossAvailability: inventories.inventory[0].storeInventory.bossAvailability,
              localStorageModel,
              productId,
              ...(geoLocation?.distance ? { distance: `${Number.parseFloat(geoLocation.distance).toFixed(1)} ${geoLocation.unitDistance.substr(0, 2)}` } : {}),
            });
          }) || [];

          commit(SET_STORES, availableStores);
          commit(SET_UNAVAILABLE_STORES, unavailableStores);

          if (!availableStores.length && btItems) {
            commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType], messageEdit: true });
          }

          if (!response?.data?.stores?.store.length) {
            commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType], messageEdit: true });
          }
          return availableStores;
        } catch (error) {
          commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType], messageEdit: true });
          return [];
        } finally {
          commit(SET_API_LOADING, false);
        }
      }
      return [];
    },

    // Common location service api call using zipcode for fetching nacys store location
    async [FETCH_STORES_BY_ZIPCODE]({
      state, commit, getters,
    }, { enteredZipCode }) {
      const { hostlink, xMacysApiKey } = getters;
      const {
        divisionNumber, resultsDisplayed, locationRadius, isBridal,
      } = state;
      const storelimit = 20; // Arbitrary limit for now
      const clientId = divisionNumber === 12 ? 'MCOM' : 'BCOM';

      const requestHeader = {
        'x-macys-apikey': xMacysApiKey,
        'X-Client-Id': clientId,
        'X-Sub-Client-Id': clientId,
      };

      try {
        commit(SET_API_LOADING, true);
        commit(SET_STORES_ERROR, null);

        const url = `${hostlink}/commonlocations/v1/locations/divn/${divisionNumber}/zipcode/${enteredZipCode}?limit=${storelimit}&radius=${locationRadius}`;
        const response = await $http.get(url, { headers: requestHeader });
        const data = [];
        const items = response?.data?.items;
        for (let index = 0; index < items.length; index += 1) {
          // If locations filled up then break loop
          if (data.length > resultsDisplayed - 1) {
            break;
          }
          const {
            name,
            workingHours,
            curbsideHours,
            locationNumber,
            storeNumber,
            attributes,
            geoLocation,
            phoneNumber,
            addresses,
          } = items[index];
          const {
            addrLine1, city, state: st, zipCode,
          } = items[index].addresses[0];
          const localStorageModel = {
            name,
            storeNumber,
            locationNumber,
            address: addresses[0],
            geoLocation,
            schedule: {
              todaysHours: workingHours ? workingHours[0] : 'Closed',
              tomorrowsHours: workingHours ? workingHours[1] : 'Closed',
            },
            lastAccessDate: workingHours ? workingHours[0].operationDate : 'Closed',
            phoneNumber,
          };
          if (divisionNumber === 13 || !isBridal) { // if BCOM ignore SL_Bridal logic
            const formattedObject = {
              name: formatStringCase(name),
              enteredZipCode,
              locationNumber,
              storeNumber,
              localStorageModel,
              address: [addrLine1, city, st, zipCode.substring(0, 5)].join(', '),
              today: workingHours ? getDisplayHoursFromLocationService(workingHours)?.today : 'Closed',
              tomorrow: workingHours ? getDisplayHoursFromLocationService(workingHours)?.tomorrow : 'Closed',
              curbsideToday: curbsideHours ? getDisplayHoursFromLocationService(curbsideHours)?.today : 'Closed',
              curbsideTomorrow: curbsideHours ? getDisplayHoursFromLocationService(curbsideHours)?.tomorrow : 'Closed',
              ...(items[index]?.geoLocation?.distance ? { distance: `${Number.parseFloat(items[index].geoLocation.distance).toFixed(1)} ${items[index].geoLocation.unitDistance.substr(0, 2)}` } : {}),
            };
            data.push(formattedObject);
          } else {
            const slBridalElement = attributes.find((attribute) => attribute.name.toUpperCase() === 'SL_BRIDAL' && attribute.value[0] === 'TRUE');
            if (slBridalElement !== undefined) {
              // Only parse if item contains SL_Bridal values
              const formattedObject = {
                name: formatStringCase(name),
                enteredZipCode,
                locationNumber,
                storeNumber,
                localStorageModel,
                address: [addrLine1, city, st, zipCode.substring(0, 5)].join(', '),
                today: workingHours ? getDisplayHoursFromLocationService(workingHours)?.today : 'Closed',
                tomorrow: workingHours ? getDisplayHoursFromLocationService(workingHours)?.tomorrow : 'Closed',
                curbsideToday: curbsideHours ? getDisplayHoursFromLocationService(curbsideHours)?.today : 'Closed',
                curbsideTomorrow: curbsideHours ? getDisplayHoursFromLocationService(curbsideHours)?.tomorrow : 'Closed',
                ...(items[index]?.geoLocation?.distance ? { distance: `${items[index].geoLocation.distance} ${items[index].geoLocation.unitDistance.substr(0, 2)}` } : {}),
              };
              data.push(formattedObject);
            }
          }
        }
        data.locationRadius = locationRadius;
        data.enteredZipCode = enteredZipCode;
        commit(SET_STORES, data);
        if (!data.length) {
          const locationType = divisionNumber === 12 ? MSTORE : BSTORE;
          commit(SET_STORES_ERROR, { error: locationType, message: ERROR_MESSAGES[locationType], messageEdit: true });
        }
        return data;
      } catch (error) {
        const errorCode = error?.response?.data?.errors?.error[0]?.errorCode || '';
        if (errorCode === '40490') {
          commit(SET_STORES_ERROR, { error: errorCode, message: ERROR_MESSAGES[errorCode], messageEdit: true });
        } else {
          const locationType = divisionNumber === 12 ? MSTORE : BSTORE;
          commit(SET_STORES, []);
          commit(SET_STORES_ERROR, {
            status: error?.response?.data?.status, error: locationType, message: ERROR_MESSAGES[locationType], messageEdit: true,
          });
        }
        return [];
      } finally {
        commit(SET_API_LOADING, false);
      }
    },
    [RESET_STORE_ACTION]({ commit }) {
      commit(RESET_STORE);
    },
    [SET_STORE]({ commit }, selectedStore) {
      commit(SET_SELECTED_STORE, selectedStore);
    },
  },
};

export default {
  locations,
};
